import {ClipboardList} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'today',
    children: [
      {
        path: '',
        loader: protectedLoader('TASKS', 'VIEW_TODAY_TASKS'),
        async lazy() {
          const {TodayPage} = await import('./pages/TodayPage');
          return {element: <TodayPage />};
        },
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/today',
    text: i18n.t('Today'),
    icon: <ClipboardList />,
    permission: 'VIEW_TODAY_TASKS',
    entitlement: 'TASKS',
  },
] as MenuItemElement[];
